import { Routes } from '@angular/router';

import bonusesRouteData from './components/bonuses/route-data';
import giftCardsRouteData from './components/gift-codes/route-data';

export default <Routes>[
  {
    path: '',
    loadComponent: async () => import('./components/page-layout/page-layout.component'),
    children: [
      {
        path: '',
        loadComponent: async () => import('./components/home/home.component')
      },
      {
        path: 'gift-cards',
        loadComponent: async () => import('./components/gift-codes/gift-codes.component'),
        data: giftCardsRouteData
      },
      {
        path: 'bonuses',
        loadComponent: async () => import('./components/bonuses/bonuses.component'),
        data: bonusesRouteData
      }
    ]
  },
  {
    path: 'success',
    loadComponent: async () => import('./components/succeed-payment/succeed-payment.component')
  },
  {
    path: 'error',
    loadComponent: async () => import('./components/failed-payment/failed-payment.component')
  }
];
